module.exports = __webpack_public_path__ + "static/media/sadKTM.3102c429.svg";